import { useSelfHiringContext } from "@/app/contexts/SelfHiringContext";
import { Table } from "@/app/entities/TableCredit";
import { useFGTSMutations } from "@/app/hooks/useFGTSMutations";
import { useSelfHiringMutation } from "@/app/hooks/useSelfHiringMutation";
import { PartnerType } from "@/app/utils/partners.enum";
import { parse } from "date-fns";
import { useMemo } from "react";
import { UseFormReturn } from "react-hook-form";
import { useParams } from "react-router-dom";

export const useInstallments = (methods: UseFormReturn<any>) => {
  const { linkName } = useParams();
  const { simulateFGTSMutation } = useFGTSMutations();
  const { setFgtsData, panData, setPanData, cltData, setCltData, type } =
    useSelfHiringContext();
  const { generateOffersPanMutation } = useSelfHiringMutation();
  const selectedCondition = useMemo(
    () =>
      panData?.state?.offers?.conditions?.find((cond) => cond.sucesso) ?? null,
    [panData?.state?.offers?.conditions],
  );

  const handleMakeProposal = () => {
    const { parcelas, ...operacoesCreditoSemParcelas } =
      selectedCondition ?? {};
    setPanData({
      ...panData,
      proposal: {
        operacoes_credito: operacoesCreditoSemParcelas,
        customerId: panData?.state.customerId,
      },
    });
  };

  const handleChangeInstallment = async (prazo?: number) => {
    if (type === PartnerType.CLT) {
      if (!prazo || !cltData?.tables?.length) return;
      const exists = cltData.tables.some((t) => t.Prazo === prazo);
      if (!exists) return;
      setCltData({ ...cltData, selectedPrazo: prazo });
      return;
    }

    if (type === PartnerType.PAN) {
      if (!panData?.state) return;

      const { customerId, transactionId, selectedValue } = panData.state;
      if (!customerId || !transactionId) return;
      if (!prazo) return;

      const formData = methods.getValues() as any;
      const cpf = formData?.cpf?.replace(/\D/g, "");
      if (!cpf || !linkName) return;

      const response = await generateOffersPanMutation.mutateAsync({
        linkName,
        payload: {
          cpf,
          prazo,
          valor: selectedValue,
          proposalId: transactionId,
        },
      });

      setPanData((prev: any) => ({
        ...prev,
        state: {
          ...panData.state,
          offers: response,
          selectedPrazo: prazo,
        },
      }));

      return;
    }

    // FGTS
    const formData = methods.getValues() as any;
    if (!formData?.cpf || !formData?.birthDate) return;
    try {
      const response = await simulateFGTSMutation.mutateAsync({
        cpf: formData.cpf,
        birthDate: parse(
          formData.birthDate,
          "dd/MM/yyyy",
          new Date(),
        ).toISOString(),
        linkName: linkName || "",
        prazo,
      });

      const validTable = response.tables.find(
        (table) => table.success === true && table.ValorLiquidoCliente > 0,
      );

      if (validTable) {
        setFgtsData((prev: any) => ({
          ...prev,
          table: validTable as unknown as Table,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    handleMakeProposal,
    handleChangeInstallment,
    reloadTable:
      type === PartnerType.PAN
        ? generateOffersPanMutation.isPending
        : type === PartnerType.CLT
          ? false
          : simulateFGTSMutation.isPending,
  };
};
